import { format, parseISO } from 'date-fns';

const convertTimestamp = (timestamp: string, convertFormat: string): string => {
  return format(parseISO(timestamp), convertFormat);
};

const toDateOnly = (data: string): string => {
  return convertTimestamp(data, 'yyyy-MM-dd');
};

const toTimeOnly = (data: string): string => {
  return convertTimestamp(data, 'HH:mm');
};

const addDays = (date: string, days: number): string => {
  const dateObject = parseISO(date);
  dateObject.setDate(dateObject.getDate() + days);
  return format(dateObject, 'yyyy-MM-dd');
};

export const DateTime = { toDateOnly, toTimeOnly, addDays };
